/* ============================================================================
   newsletter-tracking.js — suivi GA4 du popup newsletter (v2, 16/10/2026)

   PASSIF : n'appelle aucune fonction de theme.js, scratch-card.js ni
   reopen-tab.js. Il OBSERVE leurs effets visibles dans le DOM (classes
   popup--visible / is-cleared, clics sur les boutons existants).
   Retirer ce fichier + sa ligne <script> dans popup.liquid = retour a
   l'etat d'avant, rien d'autre a defaire.

   CATALOGUE DES EVENEMENTS (tout est ici, rien ailleurs) :
     newsletter_popup_shown   popup affiche           { trigger: auto | tab }
     newsletter_popup_closed  popup ferme sans envoi  { method: button | overlay | escape | other }
     newsletter_tab_clicked   clic sur l'onglet de reouverture
     newsletter_scratched     carte grattee (>= 45 %)
     newsletter_code_copied   code copie
   PARAMETRES COMMUNS a chaque evenement :
     popup_id   id du popup (utile si plusieurs popups un jour)
     site_lang  langue du site (fr / en) = Shopify.locale

   VOLONTAIREMENT ABSENTS (GA4 les fournit seul, zero code) :
     - debut de saisie      -> form_start (mesure amelioree)
     - envoi du formulaire  -> form_submit (compte aussi les echecs captcha)
     - inscription CONFIRMEE -> page_view avec ?customer_posted=true, a
       transformer en evenement `newsletter_signup` dans GA4 > Admin >
       Evenements > Creer un evenement.

   ENTONNOIR a lire dans GA4 : shown -> scratched -> code_copied -> signup.

   CONSENTEMENT : window.gtag n'existe QUE si la visiteuse a accepte les
   cookies analytiques (theme.liquid). Sans consentement il ne devient
   jamais defini et les evenements sont abandonnes : c'est voulu.
   ============================================================================ */
(function () {
  'use strict';

  /* ---------- 1. Popups newsletter de la page ---------- */
  var popups = [];
  document.querySelectorAll('.popup').forEach(function (p) {
    // Seuls les popups avec formulaire newsletter -- pas la banniere cookies.
    if (p.querySelector('[data-newsletter-form]')) popups.push(p);
  });
  if (!popups.length) return;

  /* ---------- 2. Envoi (file d'attente + 1 fois par session) ---------- */

  // gtag peut arriver apres le popup (GA4 charge au repos du navigateur,
  // jusqu'a 5 s). On retente 1 fois/s pendant 20 s puis on abandonne.
  var queue = [];
  var timer = null;
  var tries = 0;

  function flush() {
    if (typeof window.gtag === 'function') {
      queue.splice(0).forEach(function (e) { window.gtag('event', e.name, e.params); });
      clearInterval(timer);
      timer = null;
    } else if (++tries > 20) {
      queue.length = 0;
      clearInterval(timer);
      timer = null;
    }
  }

  function send(name, extra, popupId) {
    var params = {
      popup_id: popupId,
      site_lang: (window.Shopify && window.Shopify.locale) || document.documentElement.lang || ''
    };
    for (var k in extra) params[k] = extra[k];
    queue.push({ name: name, params: params });
    if (!timer) {
      tries = 0;
      timer = setInterval(flush, 1000);
    }
    flush();
  }

  // Evite de gonfler un compteur a chaque page vue / reouverture : un meme
  // (evenement + popup + variante) n'est envoye qu'une fois par session.
  function sendOnce(name, extra, popupId, variant) {
    var key = 'bymee_nl_' + name + '_' + popupId + (variant ? '_' + variant : '');
    try {
      if (window.sessionStorage.getItem(key)) return;
      window.sessionStorage.setItem(key, '1');
    } catch (e) { /* stockage bloque : on envoie quand meme */ }
    send(name, extra, popupId);
  }

  /* ---------- 3. Contexte d'interaction (poses AVANT les handlers du theme) ---------- */

  // Ecouteurs en phase de CAPTURE : ils s'executent avant ceux de theme.js et
  // reopen-tab.js, donc on connait la cause (clic croix, fond, Echap, onglet)
  // quand la classe popup--visible bascule juste apres.
  var tabClicked = false;      // le prochain affichage vient de l'onglet
  var closeMethod = 'other';   // cause de la prochaine fermeture

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest('[data-popup-close]')) closeMethod = 'button';
    else if (t.closest('[data-popup-underlay]')) closeMethod = 'overlay';
    var tab = t.closest('[data-reopen-tab]');
    if (tab) {
      tabClicked = true;
      var p = document.getElementById(tab.getAttribute('data-reopen-target'));
      send('newsletter_tab_clicked', {}, (p && p.id) || 'newsletter');
    }
    var copy = t.closest('[data-scratch-copy]');
    if (copy) {
      var pc = copy.closest('.popup');
      var idc = (pc && pc.id) || 'newsletter';
      sendOnce('newsletter_code_copied', {}, idc);
    }
  }, true);

  document.addEventListener('keyup', function (e) {
    if (e.key === 'Escape' || e.code === 'Escape') closeMethod = 'escape';
  }, true);

  /* ---------- 4. Etat des popups (un observer par popup) ---------- */
  popups.forEach(function (popup) {
    var id = popup.id || 'newsletter';
    var visible = false;
    var scratched = false;

    function check() {
      var nowVisible = popup.classList.contains('popup--visible');

      if (nowVisible && !visible) {                       // ferme -> ouvert
        var trigger = tabClicked ? 'tab' : 'auto';
        tabClicked = false;
        sendOnce('newsletter_popup_shown', { trigger: trigger }, id, trigger);
      } else if (!nowVisible && visible) {                // ouvert -> ferme
        send('newsletter_popup_closed', { method: closeMethod }, id);
        closeMethod = 'other';
      }
      visible = nowVisible;

      if (!scratched && popup.querySelector('canvas.is-cleared')) {
        scratched = true;
        sendOnce('newsletter_scratched', {}, id);
      }
    }

    // Uniquement l'attribut class : couvre popup--visible (theme.js ou
    // reopen-tab.js) et is-cleared (scratch-card.js, canvas cree apres coup).
    new MutationObserver(check).observe(popup, {
      attributes: true,
      attributeFilter: ['class'],
      subtree: true
    });
    check(); // popup deja ouvert au chargement
  });
})();
